module.exports = __webpack_public_path__ + "assets/img/mecha-9f6d26eb.png";